const USER_TYPE = {
  /**
   * 個人ユーザー
   */
  PERSONAL: { value: "1", label: "個人", isCorporate: false, isPersonal: true },
  /**
   * 法人ユーザー
   */
  CORPORATE: { value: "2", label: "法人", isCorporate: true, isPersonal: false },
} as const

export default USER_TYPE
